import { carsforsaleImport } from './carsforsaleImport'
import { snapShot } from './snapShot'
import { vehicleValue } from './vehicleValue'

export const statApi = {
  carsforsaleImport,
  snapShot,
  vehicleValue,
}
